/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Page Cashback constants
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import { IPageCashbackReducer } from './pageCashbackReducer';

export const CASHBACK_AUTO_RESERVE_ELEMENT_ID = 'auto-reserve';

/*
* -------------------------------------------
*           Initial state
* -------------------------------------------
*/

export const pageCashbackInitialState: IPageCashbackReducer = {
    accountSelectCurrent: { label: '', value: '' },
    accountSelectHasMore: false,
    accountSelectIsLoading: false,
    accountSelectList: [],
    controlServiceListAvailable: [],
    controlServiceListConnected: [],
    controlServiceListIsLoading: false,
    controlServiceListIsError: false,
    isError: false,
    isLoading: true,
    meta: {
        actions: [],
        balance: 0,
        balanceLost: {
            amount: 0,
            lostAfter: '',
        },
        balanceReserved: 0,
        isAutoSpendingEnabled: false,
        isCashbackAvailable: false,
        urlHowToGetCashback: '',
        urlHowToSpentCashback: '',
    },
    reserveError: [],
};

/*
* -------------------------------------------
*            Get Cashback Meta
* -------------------------------------------
*/

export const CASHBACK_GET_META_START = '@@b2b_portal_ui/cashback/CASHBACK_GET_META_START';
export const CASHBACK_GET_META_SUCCESS = '@@b2b_portal_ui/cashback/CASHBACK_GET_META_SUCCESS';
export const CASHBACK_GET_META_FAILURE = '@@b2b_portal_ui/cashback/CASHBACK_GET_META_FAILURE';

/*
* -------------------------------------------
*          Cashback Account Select
* -------------------------------------------
*/

export const CASHBACK_GET_ACCOUNT_LIST_START = '@@b2b_portal_ui/cashback/CASHBACK_GET_ACCOUNT_LIST_START';
export const CASHBACK_GET_ACCOUNT_LIST_SUCCESS = '@@b2b_portal_ui/cashback/CASHBACK_GET_ACCOUNT_LIST_SUCCESS';
export const CASHBACK_GET_ACCOUNT_LIST_FAILURE = '@@b2b_portal_ui/cashback/CASHBACK_GET_ACCOUNT_LIST_FAILURE';

export const CASHBACK_SET_ACCOUNT = '@@b2b_portal_ui/cashback/CASHBACK_SET_ACCOUNT';

/*
* -------------------------------------------
*        Cashback Account Control
* -------------------------------------------
*/

export const CASHBACK_GET_SERVICE_LIST_START = '@@b2b_portal_ui/cashback/CASHBACK_GET_SERVICE_LIST_START';
export const CASHBACK_GET_SERVICE_LIST_SUCCESS = '@@b2b_portal_ui/cashback/CASHBACK_GET_SERVICE_LIST_SUCCESS';
export const CASHBACK_GET_SERVICE_LIST_FAILURE = '@@b2b_portal_ui/cashback/CASHBACK_GET_SERVICE_LIST_FAILURE';

export const CASHBACK_RESERVE_START = '@@b2b_portal_ui/cashback/CASHBACK_RESERVE_START';
export const CASHBACK_RESERVE_SUCCESS = '@@b2b_portal_ui/cashback/CASHBACK_RESERVE_SUCCESS';
export const CASHBACK_RESERVE_FAILURE = '@@b2b_portal_ui/cashback/CASHBACK_RESERVE_FAILURE';

export const CASHBACK_TOGGLE_AUTO_SPENDING_START = '@@b2b_portal_ui/cashback/CASHBACK_TOGGLE_AUTO_SPENDING_START';
export const CASHBACK_TOGGLE_AUTO_SPENDING_SUCCESS = '@@b2b_portal_ui/cashback/CASHBACK_TOGGLE_AUTO_SPENDING_SUCCESS';
export const CASHBACK_TOGGLE_AUTO_SPENDING_FAILURE = '@@b2b_portal_ui/cashback/CASHBACK_TOGGLE_AUTO_SPENDING_FAILURE';
